import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {Observable, of, race, timer} from "rxjs";
import {Payment} from '../../user/payment';
import {WorkspaceService} from "../workspace.service";
import {filter, switchMap, first, map, take} from "rxjs/operators";
import {TypeUtils} from "../../shared/utils/type-utils";
import {Store} from "@ngrx/store";
import * as fromStore from "../../store";


@Injectable()
export class PaymentsResolver implements Resolve<Payment[]|null> {

    constructor(
        private _store: Store<fromStore.DbStoreState>,
        private _workspaceService: WorkspaceService
    ) {
    }

    resolve(): Observable<any> | Promise<any> | any {
        return new Promise((resolve: Function, reject: Function): void => {
            this._store.select(fromStore.getUserLoaded)
                .pipe(
                    filter((loaded: boolean) => loaded),
                    switchMap(() => this._store.select(fromStore.getUser)),
                    first()
                )
                .subscribe((user) => {
                    // If no user exists (checkout, not logged in), resolve with null
                    if (!user || TypeUtils.isNull(user)) {
                        resolve(null);
                        return;
                    }

                    // Check if subscription is non-billable or trial
                    this._store.select(fromStore.getUserSubscription)
                        .pipe(first())
                        .subscribe(userSubscription => {
                            // If subscription is non-billable or trial, skip loading payments
                            if (userSubscription && (userSubscription.is_non_billable === true || userSubscription.trialClient)) {
                                console.log('[PaymentsResolver] Non-billable or trial user, skipping payments load');
                                resolve(null);
                                return;
                            }

                            // User exists and is billable, get payments
                            // Add race condition with timeout to prevent hanging
                            race(
                                this._store.select(fromStore.getPaymentsLoaded).pipe(
                                    filter((loaded: boolean) => loaded),
                                    switchMap(() => this._store.select(fromStore.getPayments)),
                                    first()
                                ),
                                timer(5000).pipe(map(() => null)) // 5 second timeout
                            )
                                .pipe(first())
                                .subscribe(data => {
                                    console.log('[PaymentsResolver] Payments data resolved:', data);
                                    if (data && !TypeUtils.isNull(data)) {
                                        resolve(data);
                                    } else {
                                        console.warn('[PaymentsResolver] Payments not loaded or timed out, resolving with null');
                                        resolve(null);
                                    }
                                });
                        });
                });
        });
    }
}
